import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const apkBuildsRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  return router.createUrlTree(['/admin'], { queryParams: { tab: 'builds' } });
};
